import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/axiosConfig';
import PageLoadingArea from '../../components/PageLoader/PageLoadingArea';
import usePageLoading from '../../hooks/usePageLoading';
import '../../styles/ListPage.css';

function LedgerClients() {
    const [clients, setClients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const { isLoading, withLoading } = usePageLoading(true);

    useEffect(() => {
        withLoading(async () => {
            const res = await api.get('/clients');
            setClients(res.data);
        }).catch((error) => {
            console.error('Error fetching clients:', error);
            alert('Error fetching clients');
        });
    }, [withLoading]);

    const filteredClients = clients.filter(client =>
        (client.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (client.gstNo || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (client.panNo || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <PageLoadingArea isLoading={isLoading}>
            <div className="list-page">
                <div className="list-page-header">
                    <div className="list-page-title">
                        <h1>Client Ledgers</h1>
                        <p className="list-page-subtitle">
                            {filteredClients.length} client{filteredClients.length === 1 ? '' : 's'}
                        </p>
                    </div>
                    <div className="list-header-actions">
                        <div className="list-search-wrap">
                            <input
                                type="text"
                                placeholder="Search name, GST, or PAN"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="list-search-input"
                            />
                        </div>
                        <div className="list-button-group">
                            <button
                                type="button"
                                onClick={() => navigate('/financials')}
                                className="list-secondary-button"
                            >
                                Back to financials
                            </button>
                        </div>
                    </div>
                </div>

                <div className="list-table-card">
                    <div className="list-table-scroll">
                        <table className="list-table">
                            <thead>
                                <tr>
                                    <th>Sr No</th>
                                    <th>Name</th>
                                    <th>GST No</th>
                                    <th>PAN No</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredClients.length === 0 ? (
                                    <tr className="list-empty-row">
                                        <td colSpan="4">
                                            <div className="list-empty-state">
                                                <h3>No clients found</h3>
                                                <p>{searchTerm ? 'Try a different search term.' : 'No clients available yet.'}</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : filteredClients.map((client, index) => (
                                    <tr
                                        key={client.id}
                                        className="list-row"
                                        onClick={() => navigate(`/ledgerDetails/${client.id}`)}
                                    >
                                        <td>{index + 1}</td>
                                        <td><span className="list-primary-text">{client.name}</span></td>
                                        <td>{client.gstNo}</td>
                                        <td>{client.panNo}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </PageLoadingArea>
    );
}

export default LedgerClients;
